export default __webpack_public_path__ + "static/7 Habits of Healthy Sleepers-2558f87e838eab4911ebeb32de56b924.jpg";